import { IArticlesItem } from "../interfaces";

// serialize articles response to common interface IArticlesItem objects
export const serializeArticles = (jsonData: any): IArticlesItem[] => {
  let articles: IArticlesItem[] = [];

  for (let article of jsonData) {
    const articleEntities = article["article_entities"] ? article["article_entities"].join(", ") : "";
    articles.push({
      id: article["article_id"],
      title: article["article_title"],
      description: article["article_description"],
      image_url: article["article_image"],
      website: article["article_domain"],
      publish_date: article["article_publish_timestamp"],
      is_favourite: article["article_is_favourite"],
      views: article["article_views"],
      is_cms: article["article_is_cms"],
      is_curated: article["article_is_curated"],
      entities: articleEntities,
      link: article["article_link"],
      thumbnail: article["article_thumbnail"],
      image_server: article["article_image_server"],
      fullDescription: article["highlighted_description"],
    });
  }

  return articles;
};

// serialize single article json to IArticleItem interface
export const serializeArticle = (jsonData: any): IArticlesItem => {
  let articles: IArticlesItem;
  let article = jsonData;
  articles = {
    id: article["article_id"],
    title: article["article_title"],
    description: article["article_description"],
    image_url: article["article_image"],
    website: article["article_domain"],
    publish_date: article["article_publish_timestamp"],
    entities: article["article_entities"],
    is_loading: false,
    is_removingFailed: false,
    tags: "tags",
    is_cms: article["article_is_cms"],
    is_curated: article["article_is_curated"],
    link: article["article_link"],
    is_favourite: article["article_is_favourite"],
    views: article["article_views"],
    resource_article_id: article["resource_article_id"],
  };

  return articles;
};
